import { render } from "./blog_evento_ingles.vue?vue&type=template&id=68cee758&scoped=true"
import script from "./blog_evento_ingles.vue?vue&type=script&lang=js"
export * from "./blog_evento_ingles.vue?vue&type=script&lang=js"

import "./blog_evento_ingles.vue?vue&type=style&index=0&id=68cee758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cee758"]])

export default __exports__